import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint, } from './helpers.js';
export const streaming = (rawClient) => ({
    vod: {
        /**
         * Request that an HLS VOD stream be produced for a media URL hosted on
         * this server. Idempotent: returns the existing stream's status when
         * called again with the same source URL.
         */
        create: allpeepPayloadEndpoint(rawClient, '/streaming/vod', 'post'),
        /** Polls the current status of a previously-created VOD stream. */
        status: allpeepNoPayloadEndpoint(rawClient, '/streaming/vod/:storageId/status'),
    },
});
